import {
  AggregationFunction,
  AttributeConfigurationDc,
  AttributeType,
  ColumnDescriptionDc,
  StringSubType,
  LayerDefinitionDc,
} from "@evergis/api";
import { createNewAttribute } from "./createNewAttribute";
import { filterGeometryAttributes, isGeometryType } from "./attributes";
import { LayerAttribute } from "../../../components/Dialogs/EditResource/components/Layer/LayerAttributeItem";

export function createLayerAttributes(
  layerAttributes?: AttributeConfigurationDc[],
  tableColumns?: ColumnDescriptionDc[],
  layerDefinition?: LayerDefinitionDc,
): LayerAttribute[] | undefined {
  const visibleAttributes = layerAttributes
    .filter(({ tableName }) => !tableName)
    .map(attribute => {
      const column = layerDefinition.attributes[attribute.columnName];

      const additionalProps = column
        ? { type: column.type }
        : attribute.expression
        ? {
            type: layerDefinition.attributes[attribute.attributeName].type,
          }
        : {
            deleted: true,
            type: AttributeType.String,
          };

      return createNewAttribute({ ...attribute, ...additionalProps });
    });

  const hiddenAttributes = tableColumns
    .filter(column => !columnInLayer(layerAttributes, column))
    .map(column => createLayerAttribute(column));

  const geometryAttributes = visibleAttributes.filter(({ type }) => isGeometryType(type));

  return [...filterGeometryAttributes(visibleAttributes), ...hiddenAttributes, ...geometryAttributes];
}

function columnInLayer(layerAttributes: AttributeConfigurationDc[], column: ColumnDescriptionDc): boolean {
  return layerAttributes.some(({ columnName }) => columnName === column.name);
}

export function findColumn(tableColumns: ColumnDescriptionDc[], columnName: string): ColumnDescriptionDc {
  return tableColumns.find(({ name }) => name === columnName);
}

export function createLayerAttribute(
  column: ColumnDescriptionDc & { subType?: StringSubType },
  isDisplayed = false,
): LayerAttribute {
  const aggregation: AggregationFunction = AggregationFunction.None;

  return createNewAttribute({
    id: column.name,
    attributeName: column.name,
    columnName: column.name,
    type: column.type,
    subType: column.subType,
    aggregation,
    isDisplayed,
  });
}
